<template>
  <v-dialog v-model="dialog" content-class="password-dialog" max-width="570" @input="beforeClose">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mt-2 button-height" width="156" :color="getAssets.colors.form.buttonBackground" outlined v-bind="attrs" v-on="on"> alterar senha </v-btn>
    </template>
    <v-card>
      <v-card-text class="py-0 pt-5">
        <p class="title mt-3" :style="{ color: getAssets.colors.form.buttonBackground }">Alterar senha</p>
        <p class="subtitle mb-6">Primeiro confirme que é você mesmo. Digite sua senha atual:</p>
        <v-text-field
          v-model="password"
          outlined
          :type="showPassword ? 'text' : 'password'"
          label="Senha atual"
          :error-messages="errorPassword"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @input="errorPassword = ''"
          @click:append="showPassword = !showPassword"
        />
        <p class="subtitle mb-6">Agora basta digitar e confirmar sua senha. Ela deve ter no mínimo 6 caracteres, ok?</p>
        <v-text-field
          v-model="newPassword"
          outlined
          :type="showNewPassword ? 'text' : 'password'"
          label="Nova senha"
          :error-messages="errorNewPassword"
          :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @input="errorNewPassword = ''"
          @click:append="showNewPassword = !showNewPassword"
        />
        <v-text-field
          v-model="confirmPassword"
          outlined
          class="mt-2"
          :type="showConfirmPassword ? 'text' : 'password'"
          label="Confirme sua nova senha"
          :error-messages="errorConfirmPassword"
          :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @input="errorConfirmPassword = ''"
          @click:append="showConfirmPassword = !showConfirmPassword"
        />
      </v-card-text>
      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn :color="getAssets.colors.form.buttonBackground" width="110" class="button-height" text @click="dialog = false">cancelar</v-btn>
        <v-btn
          width="110"
          class="button-height"
          :color="getAssets.colors.form.buttonBackground"
          :style="{ color: getAssets.colors.form.buttonFont }"
          :loading="submitLoading"
          @click="submit"
          >concluir</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ResetPassword',
  data: () => ({
    dialog: false,
    showPassword: false,
    showNewPassword: false,
    showConfirmPassword: false,
    password: '',
    newPassword: '',
    confirmPassword: '',
    errorPassword: '',
    errorNewPassword: '',
    errorConfirmPassword: '',
    submitLoading: false
  }),
  computed: {
    cpfCnpj() {
      return this.$store.getters.USER_INFO.document_no
    },
    getAssets() {
      return this.$store.getters.GET_ASSETS
    }
  },
  methods: {
    beforeClose() {
      this.password = ''
      this.newPassword = ''
      this.confirmPassword = ''
      this.errorPassword = ''
      this.errorNewPassword = ''
      this.errorConfirmPassword = ''
    },
    validate(password) {
      const response = {
        valid: true,
        msg: ''
      }

      if (!password) {
        response.valid = false
        response.msg = 'Esse campo é obrigatório.'
        return response
      }

      if (password.length < 6) {
        response.valid = false
        response.msg = 'Esse campo precisa ter pelo menos 6 caracteres.'
        return response
      }

      if (!password || password.trim().length === 0) {
        response.valid = false
        response.msg = 'Esse campo não pode conter apenas espaços.'
        return response
      }

      return response
    },
    submit() {
      const validatePassword = this.validate(this.newPassword)
      const validateConfirm = this.validate(this.confirmPassword)
      if (!this.password) {
        this.errorPassword = 'Esse campo é obrigatório.'
        return
      }
      if (!validatePassword.valid || !validateConfirm.valid) {
        this.errorNewPassword = validatePassword.msg
        this.errorConfirmPassword = validateConfirm.msg
        return
      }

      if (this.newPassword !== this.confirmPassword) {
        this.errorNewPassword = 'As senhas não são iguais.'
        this.errorConfirmPassword = 'As senhas não são iguais.'
        return
      }

      this.submitLoading = true
      this.$store
        .dispatch('changePassword', {
          oldPassword: this.password,
          newPassword: this.newPassword
        })
        .then(() => {
          this.dialog = false
          this.$emit('updated')
        })
        .catch(err => {
          if (err.response?.errors?.[0]?.message === 'Password not match') {
            this.errorPassword = 'Senha incorreta'
          } else {
            console.error(err)
            this.$snackbar({ message: 'Erro ao alterar senha', snackbarColor: 'error' })
          }
        })
        .finally(() => {
          this.submitLoading = false
        })
    }
  }
}
</script>

<style lang="scss">
.password-dialog {
  .title {
    font-size: 32px;
    text-align: center;
    margin-bottom: 0px !important;
  }
  .subtitle {
    font-size: 14px;
    color: #6b7580;
    max-width: 400px;
    margin: auto;
    text-align: center;
    line-height: 120%;
    letter-spacing: 0.02em;
  }
  .v-input__slot {
    margin-bottom: 0px !important;
  }
}
</style>
